import $axiosProtected from "../common/utils/axiosUtils";

export const onboardCHW = async (payload: any) => {
  return await $axiosProtected().post("/acc/chw/store", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
